import { Component, OnInit } from '@angular/core';
import { LoadingController, ModalController, ToastController } from '@ionic/angular';
import { isNotEmptyArray, isNotNullAndUndefined } from 'src/app/utilities/utils';
import { BackendCallService } from 'src/app/services/backend-call/backend-call.service';
import { NavigationExtras, Router } from '@angular/router';

@Component({
  selector: 'app-view-opportunities',
  templateUrl: './view-opportunities.component.html',
  styleUrls: ['./view-opportunities.component.scss'],
})
export class ViewOpportunitiesComponent implements OnInit {
  opporData: any;
  getOpportDataList = [];
  opportunityLists = [];
  opportunityId: any;
  companyName: any;
  status: any;
  searchTerm: any;
  opportunityIdData: any;
  opportunitySearchbarExpand=false;
  showSearchBar = false;
  constructor(public loadingController: LoadingController,public modalController: ModalController, public backendService: BackendCallService, private router: Router,) { }

  ngOnInit() { }

  ionViewWillEnter() {
    this.getOpportunities();
  }

  close() {
    const _self = this;
    _self.modalController.dismiss({
      dismissed: true,
    });
  }

  async presentLoading(msg) {
    const loading = await this.loadingController.create({
      cssClass: 'my-custom-loading',
      message: msg,
      spinner: 'bubbles'
    });
    await loading.present();
    return loading;
  }

  async getOpportunities() {
    if (isNotEmptyArray(this.getOpportDataList)) {this.getOpportDataList = [];}
    const _self = this;
    this.getOpportDataList = [];
    _self.backendService.getOpportunitiesData().subscribe(res => {
      _self.opporData = res;
      this.opporData.value.forEach((element) => {
        this.getOpportDataList.push({
          oppoId: element.opportunityId,
          companyName: element.customer_Name,
          projectId:element.projectId,
          erp_Project_Id:element.erp_Project_Id,
          status: element.status,
        });
      });
      this.opportunityLists = JSON.parse(JSON.stringify(this.getOpportDataList));
    }, error => {
      (err) => {
      };
    });
  }

  redirectToOffer(eachOpp) {
    this.opportunityIdData = eachOpp.oppoId;
    const navigationExtras: NavigationExtras = {
      queryParamsHandling: 'merge',
      queryParams: {
        offerOpporId: this.opportunityIdData,
        isViewOpportunities: true,
        project_id:eachOpp.projectId,
        pageName: 'viewOpp'
      },
      state: {
        // pageName: "viewOpp"
      },
    };
    this.router.navigate(['offer-management/create-offer'], navigationExtras);
    this.close();
  }


  opportunitySearch(event) {
    const value  = event.target.value;
    if (value && isNotEmptyArray(this.getOpportDataList)) {
      this.opportunityLists = this.getOpportDataList.filter(_bkpl => (
          (isNotNullAndUndefined(_bkpl.oppoId) ? (_bkpl.oppoId.toLowerCase().indexOf(value.toLowerCase())) > -1 : false) ||
          (isNotNullAndUndefined(_bkpl.companyName) ? (_bkpl.companyName.toLowerCase().indexOf(value.toLowerCase())) > -1 : false) ||
          (isNotNullAndUndefined(_bkpl.erp_Project_Id) ? (_bkpl.erp_Project_Id.toLowerCase().indexOf(value.toLowerCase())) > -1 : false) ||
          (isNotNullAndUndefined(_bkpl.status) ? (_bkpl.status.toLowerCase().indexOf(value.toLowerCase())) > -1 : false) ||
          (isNotNullAndUndefined(_bkpl.projectId) ? (_bkpl.projectId.toLowerCase().indexOf(value.toLowerCase())) > -1 : false)
        ));
    } else {
      this.opportunityLists = JSON.parse(JSON.stringify(this.getOpportDataList));
    }
  }

}
